import { render, staticRenderFns } from "./ReviewStep.vue?vue&type=template&id=216a30a8"
import script from "./ReviewStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewStep.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReviewStep.vue?vue&type=style&index=0&id=216a30a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports